import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { MMKVEdTechStoreKeyMap } from "../mmkv/mmkvEdTechStoreKeyMap";
import { zustandEdTechAppStorage } from "../mmkv/mmkvEdTechAppPersistence";

type AppSettings = {
  edTechAppLanguage: string;
  setEdTechAppLanguage: (languageKey: string) => void;
  edTechAppLanguageLabel: string;
  setEdTechAppLanguageLabel: (languageLabel: string) => void;
  activeProductTabLanguages: string[];
  setActiveProductTabLanguages: (enabledLanguages: string[]) => void;

};

export const useAppPersistenceEdTechStore = create<AppSettings>()(
  persist(
    (set,get) => ({
      edTechAppLanguage: get()?.edTechAppLanguage ?? 'hi',
      edTechAppLanguageLabel:  get()?.edTechAppLanguageLabel ?? 'Hindi',
      cart: [],
      setEdTechAppLanguage: (languageKey) =>
        set(() => ({ edTechAppLanguage: languageKey })),
      setEdTechAppLanguageLabel: (languageLabel) =>
        set(() => ({ edTechAppLanguageLabel: languageLabel })),
      activeProductTabLanguages: ['hi', 'en'],
      setActiveProductTabLanguages: (activeLanguages) =>
        set(() => ({ activeProductTabLanguages: activeLanguages })),
    }),
    {
      name: MMKVEdTechStoreKeyMap.edTechAppSettings,
      storage: createJSONStorage(() => zustandEdTechAppStorage),
    }
  )
);
